import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import type { AuthenticationResult } from "@azure/msal-browser";
import { extractRolesFromAccount } from "@/app/providers/useAuth";
import { backendLogin } from "@/services/api/auth";

export function MsalRedirectHandler() {
  const { instance, inProgress } = useMsal();

  useEffect(() => {
    if (inProgress !== "none") {
      return;
    }

    const handleRedirect = async () => {
      try {
        const response: AuthenticationResult | null =
          await instance.handleRedirectPromise();
        if (!response) {
          return;
        }

        instance.setActiveAccount(response.account);

        const roles = extractRolesFromAccount(response.account);
        if (!roles || roles.length === 0) {
          window.location.assign("/auth/unauthorized");
          return;
        }

        try {
          await backendLogin();
        } catch (loginError) {
          console.error("Backend login failed after redirect:", loginError);
        }

        const searchParams = new URLSearchParams(window.location.search);
        const redirectParam = searchParams.get("redirect");
        const redirectUrl = redirectParam || "/home";
        window.location.assign(redirectUrl);
      } catch (error) {
        console.error("Error handling redirect promise:", error);
      }
    };

    void handleRedirect();
  }, [instance, inProgress]);

  return null;
}
